// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"2d82bbe6","136":"593aeca5"}[chunkId] + ".chunk.css";
};